<template>
  <div class="home">
    <div class="header">
      <add-companys @success="getList"></add-companys>
      <qzf-import type="company" name="公司" @success="getList()"></qzf-import>
      <div style="float:right">
        <collection-company @success="getList"></collection-company>
        <pz-device></pz-device>
      </div>
    </div>
    <!-- content -->
    <el-row :gutter="20">
      <el-col :span="12">
        <div>
          <el-table size="mini" :data="userList"  border style="width: 100%" :header-cell-style="{background:'#66b1ff',color:'#ffff'}">
            <el-table-column fixed type="index" width="50" label="序号" align="center"></el-table-column>
            <el-table-column prop="name" label="代账公司名" align="center"/>
            <el-table-column prop="userName" label="用户名" align="center"/>
            <el-table-column prop="password" label="密码" align="center"/>
            <el-table-column prop="mac" label="mac地址" align="center"/>
            <el-table-column fixed="right" label="操作" min-width="140" align="center">
              <template v-slot="scope">
                <el-button type="text" size="small" @click="edit(scope.row)">修改mac地址</el-button>
                <el-button type="text" size="small" @click="add(scope.row)">添加</el-button>
                <el-button type="text" size="small" @click="handleClick(scope.row)">查看公司</el-button>
                <el-popconfirm
                  confirm-button-text="确认"
                  cancel-button-text="取消"
                  icon="el-icon-info"
                  icon-color="red"
                  title="确认删除"
                  @confirm="deleteUser(scope.row)"
                >
                  <template #reference>
                    <el-button type="text" size="small">删除</el-button>
                  </template>
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <qzf-pagination v-show="userTotal>0" :total="userTotal" v-model:page="listQuery.page" v-model:limit="listQuery.limit" @pagination="getList" />
          </div>
        </div>
      </el-col>
      <el-col :span="12">
        <div>
          <el-table size="mini" :data="companyList"  border style="width: 100%" :header-cell-style="{background:'#66b1ff',color:'#ffff'}">
            <el-table-column fixed type="index" width="50" label="序号" align="center"></el-table-column>
            <el-table-column prop="name" label="公司名" align="center"/>
            <el-table-column prop="tax_no" label="纳税人识别号" align="center"/>
            <el-table-column prop="type" label="企业类型" align="center">
              <template v-slot="scope">
                {{filter(scope.row.type)}}
              </template>
            </el-table-column>
            <el-table-column prop="jqbh" label="机器编号" align="center"/>
            <el-table-column fixed="right" label="操作" align="center">
              <template v-slot="scope">
                <el-popconfirm
                  confirm-button-text="确认"
                  cancel-button-text="取消"
                  icon="el-icon-info"
                  icon-color="red"
                  title="确认删除"
                  @confirm="deleteCompany(scope.row)"
                >
                  <template #reference>
                    <el-button type="text" size="small">删除</el-button>
                  </template>
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <qzf-pagination v-show="companyTotal>0" :total="companyTotal" v-model:page="listQuery2.page" v-model:limit="listQuery2.limit" @pagination="getListCompany" />
          </div>
        </div>
      </el-col>
    </el-row>
    <!-- 添加操作 -->
    <el-dialog
      v-model="dialogFormVisible"
      title="添加公司"
      width="30%"
      :before-close="handleClose"
    >
    <el-form :model="temp">
      <el-form-item label="公司名称：" :label-width="formLabelWidth">
        <el-input class="input" size="mini" v-model="temp.name"></el-input>
      </el-form-item>

      <el-form-item label="纳税人识别号：" :label-width="formLabelWidth">
        <el-input class="input" size="mini" v-model="temp.tax_no"></el-input>
      </el-form-item>

      <el-form-item label="公司类型：" :label-width="formLabelWidth">
        <el-select size="mini" v-model="temp.type" placeholder="请选择" clearable>
          <el-option v-for="item in types" :key="item.value" :label="item.name" :value="item.value"></el-option>
        </el-select>
      </el-form-item>

      <!-- <el-form-item label="用户名：" :label-width="formLabelWidth">
        <el-input class="input" size="mini" v-model="temp.userName"></el-input>
      </el-form-item> -->

      <!-- <el-form-item label="密码：" :label-width="formLabelWidth">
        <el-input class="input" size="mini" v-model="temp.password"></el-input>
      </el-form-item> -->

      
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button size="mini" @click="dialogFormVisible = false">取消</el-button>
        <el-button size="mini" type="primary" @click="saveCompany()">确认</el-button>
      </span>
    </template>
    </el-dialog>
    <!-- 修改mac地址 -->
    <el-dialog v-model="dialogMacVisible" title="修改mac地址" width="30%" :before-close="handleClose">
      <el-select v-model="macValue" multiple placeholder="请选择mac地址" @change="changeValue" size="mini">
        <el-option v-for="item in options" :key="item.mac" :label="item.name+'-'+item.mac" :value="item.mac"></el-option>
      </el-select>
      <template #footer>
        <span class="dialog-footer">
          <el-button size="mini" @click="dialogMacVisible = false">取消</el-button>
          <el-button size="mini" type="primary" @click="confirm"
            >确认</el-button
          >
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import { defineComponent, ref, onBeforeUnmount } from 'vue'
import { userList, delUser, companyList, delCompany , addCompany ,zyDeviceList, saveOrg} from "@/api/ea";
import addCompanys from "@/components/addCompany";
import pzDevice from "./components/pzDevice";
import collectionCompany from "./components/collectionCompany";

export default {
  components: { addCompanys, collectionCompany, pzDevice },
  name: 'admin',
  data() {
    return {
      userList: [],
      dialogFormVisible: false,
      dialogMacVisible:false,
      formLabelWidth: "110px",
      userTotal: 0,
      listQuery: {
        page: 1,
        limit: 10,
      },
      companyList: [],
      companyTotal: 0,
      listQuery2: {
        userId: 0,
        page: 1,
        limit: 10,
      },
      types: [{
        name: "小规模纳税人",
        value: 1,
      },{
        name: "一般纳税人",
        value: 2,
      }],
      temp: {},
      options:[],
      macValue:'',
      macId:undefined,
      macAddress:undefined
    }
  },
  created () {
    this.getList()
  },
  methods: {
    deleteCompany(row){
      delCompany([row]).then(res=>{
        if(res.data.msg == "success"){
          this.$qzfMessage("删除成功")
          this.getListCompany()
        }
      })
    },
    getListCompany(){
      companyList(this.listQuery2).then(res=>{
        this.companyList = res.data.data.list
        this.companyTotal = res.data.data.total
      })
    },
    handleClick(row){
      this.listQuery2.userId = row.id
      this.getListCompany()
    },
    getList(){
      userList(this.listQuery).then(res=>{
        this.userList = res.data.data.list
        this.userTotal = res.data.data.total
      })
    },
    deleteUser(row){
      delUser([row]).then(res=>{
        if(res.data.msg == "success"){
          this.$qzfMessage("删除成功")
          this.getList()
        }
      })
    },
    filter(n){
      if(n == 1){
        return '小规模纳税人'
      }else if(n == 2){
        return '一般纳税人'
      }
    },
    add(row){
      this.dialogFormVisible = true
      console.log(row.userName);
      this.temp.userName = row.userName
    },
    saveCompany(){
      if(!this.temp.name){
        this.$qzfMessage("请输入公司名称", 1)
        return
      }
      if(!this.temp.tax_no){
        this.$qzfMessage("请输入纳税人识别号", 1)
        return
      }
      if(!this.temp.type){
        this.$qzfMessage("请选择公司类型", 1)
        return
      }
      addCompany([this.temp]).then(res=>{
        if(res.data.msg == "success"){
          this.$qzfMessage("添加成功")
          this.dialogFormVisible = false
          this.$emit("success")
        }
      })
    },
    edit(row){
      this.macId = row.orgId
      this.macValue = row.mac?row.mac.split(','):[]
      this.dialogMacVisible = true
      zyDeviceList().then(res=>{
        this.options = res.data.data.list
      })
    },
    changeValue(val){
      this.macAddress = val.join(",")
    },
    confirm(){
      let params = {
        id:this.macId,
        mac:this.macAddress
      }
      console.log(params);
      saveOrg(params).then(res=>{
        if(res.data.msg == "success"){
          this.dialogMacVisible = false
          this.getList()
          this.$qzfMessage("修改成功")
        }
      })
    }
  },
  
}
</script>
<style lang="scss" scoped>
.input-set{
  width: 200px;
  margin-right: 10px;
}
.header{
  padding: 10px 10px 10px 0;
}
.pagination{
  text-align: right;
  margin-right: 26px;
  margin-top: 16px;
}
.input{
  width: 200px;
}
</style>